var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.text && _vm.textParts.length > 0)?_c('div',{staticClass:"highlight-text-container",class:( _obj = {}, _obj[_vm.className] = _vm.className, _obj )},[_vm._l((_vm.textParts),function(item){return [_c('span',{staticClass:"normal-text",class:{ 'highlight-text': item.highlight },style:(item.highlight ? _vm.highlightStyle : _vm.normalStyle)},[_vm._v(_vm._s(item.text))])]})],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }